import { render } from "./ForBrands.vue?vue&type=template&id=147cadb2&scoped=true"
import script from "./ForBrands.vue?vue&type=script&lang=js"
export * from "./ForBrands.vue?vue&type=script&lang=js"

import "./ForBrands.vue?vue&type=style&index=0&id=147cadb2&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-147cadb2"]])

export default __exports__